/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
import Download from 'wix-ui-icons-common/on-stage/Download';
var download = function (_a) { return (React.createElement(Download, null)); };
download.displayName = 'download';
download.propTypes = {
    size: PropTypes.string
};
export default download;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=download.js.map